import React, { useEffect, useState } from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import SourceAccount from "app/shared/components/source-account/source-account";
import { Constant } from "app/shared/constant/constant";

import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ScreenNameType from "@navigation/nav-screens";
import { ACCOUNT } from "app/shared/services/services-model.type";
import FormTermDeposit from "./form-term-deposit-open/form-term-deposit-open.web";
import {
  fetchTermDepositInfoRequest,
  fetchTermDepositOpenCreateRequest,
  fetchTermDepositPromoCodeRequest,
  setTermOpenReset,
  setTermOpenStore,
} from "../reducer/actions";
import { getTermDepositInfoSelector, getTermDepositOpenSelector } from "../reducer/selectors";
import { DataTermDepositCreate } from "../reducer/types";
import StackParamsList from "app/navigation/nav-stack-params";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import { showModal } from "app/modules/modal-management/reducer/action";
import { getTermDepositMaturityName, getTermDepositProductName } from "../../term-deposit-utils/term-deposit.utils";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.TERM_DEPOSIT_OPEN_CREATE>;

const TermDepositOpen = () => {
  const { dispatch, navigate } = useNavigation();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("FUNC_MO_SO_TK"),
      onPressSubtitle: () => {},
    },
  ];

  const routeProps = useRoute<ProfileScreenRouteProp>();
  const termOpenStore = useSelector(getTermDepositOpenSelector);
  const termInfo = useSelector(getTermDepositInfoSelector);
  const contactId = useSelector(getContactIdSelector);

  const [accountDebit, setAccountDebit] = useState<ACCOUNT>({});
  const [isValidAccount, setIsValidAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const eventPushCleverTap = (status: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onCancel = () => {
    eventPushCleverTap(false);
    dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
  };

  // Submit Create
  const onSubmit = () => {
    setIsSubmit(true);
  };

  const onChangeAccountDebit = (account: ACCOUNT, isValid: boolean) => {
    setAccountDebit(account);
    setIsValidAccount(isValid);
  };

  const requestCreate = (data: DataTermDepositCreate) => {
    console.log("accountDebit: ", accountDebit);
    console.log("isValidAccount: ", isValidAccount);
    if (accountDebit.ACCOUNTNO?.length && isValidAccount) {
      data.ACCOUNT_DEBIT = accountDebit;
      if (data.PROMO_CODE !== "") {
        dispatchStore(fetchTermDepositPromoCodeRequest(data));
      } else {
        dispatchStore(fetchTermDepositOpenCreateRequest(data));
      }
    }
  };

  const handlerAcceptDialog = () => {
    console.log("handlerAcceptDialog: ", termOpenStore.responseCreate);
    let data: DataTermDepositCreate = {
      ...termOpenStore.dataCreate,
      AMOUNT: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.TRANSACTION_AMOUNT,
      PRODUCT: {
        value: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.PRODUCT_CODE || termOpenStore.dataCreate?.PRODUCT?.value || "",
        label: getTermDepositProductName(
          termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.PRODUCT_CODE || termOpenStore.dataCreate?.PRODUCT?.label || "",
        ),
      },
      TERM: {
        value: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.DEPOSIT_TERM || termOpenStore.dataCreate?.TERM?.value || "",
        label: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.DEPOSIT_TERM_CODE || termOpenStore.dataCreate?.TERM?.value || "",
      },
      MATURITY: {
        value: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.RENEWAL_CODE || termOpenStore.dataCreate?.MATURITY?.value || "",
        label: getTermDepositMaturityName(
          termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.RENEWAL_CODE || termOpenStore.dataCreate?.MATURITY?.label || "",
        ),
      },
      BRANCH: {
        value: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.CREDIT_BRANCH_CODE || termOpenStore.dataCreate?.BRANCH?.value || "",
        label: termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.CREDIT_BRANCH_CODE || termOpenStore.dataCreate?.BRANCH?.label || "",
      },
    };
    dispatchStore(setTermOpenStore({ ...termOpenStore, dataCreate: data, statusCreate: "init", isChangeDataByPromoCode: true }));
  };

  const handlerParamsCleverTap = (status: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: status ? "Tiếp tục" : "Hủy",
      ct_create_deposit_product: termOpenStore.dataCreate?.PRODUCT?.value,
      ct_create_deposit_term: (termOpenStore.dataCreate?.TERM?.value || "") + termOpenStore.dataCreate?.TERM?.label,
      ct_create_deposit_amount: termOpenStore.dataCreate?.AMOUNT,
      ct_create_deposit_maturity: termOpenStore.dataCreate?.MATURITY?.value,
      ct_create_deposit_branch: termOpenStore.dataCreate?.BRANCH?.value,
    };
    if (response) {
      param = {
        ...param,
        ct_create_deposit_status: response || "",
      };
    }
    return {
      eventNameCT: "ct_create_deposit",
      paramsCT: param,
    };
  };

  useEffect(() => {
    console.log("Khởi tạo");
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setTermOpenReset());
      dispatchStore(fetchTermDepositInfoRequest());
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  useEffect(() => {
    if (isSubmit) setIsSubmit(false);
  }, [isSubmit]);

  useEffect(() => {
    if (termOpenStore.isCreated) {
      if (termOpenStore.responseCreate?.EBACCOUNT_DEPOSITS?.MATCH == "false") {
        dispatchStore(
          showModal({
            modalType: "multiAction",
            modalProps: {
              open: true,
              message: t("SAVING_INFO_NOT_MATCH_PROMO"),
              acceptModal: handlerAcceptDialog,
            },
          }),
        );
      } else {
        const { eventNameCT, paramsCT } = handlerParamsCleverTap(true, "success");
        pushCleverTapEvent(eventNameCT, paramsCT);
        navigate(ScreenNameType.TERM_DEPOSIT_OPEN_CONFIRM);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, termOpenStore.isCreated]);

  useEffect(() => {
    if (termOpenStore.statusCheckCode === "ok") {
      dispatchStore(fetchTermDepositOpenCreateRequest(termOpenStore.dataCreate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termOpenStore.statusCheckCode]);

  useEffect(() => {
    if (termOpenStore.statusCreate === "pending") {
      eventPushCleverTap(true);
    }
    if (termOpenStore.statusCreate === "error") {
      eventPushCleverTap(true, "failure" + (termOpenStore.errorMsg || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termOpenStore.statusCreate]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("FUNC_MO_SO_TK")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <StepProcessUniversal currentSteps={0} />
          <SourceAccount
            onChangeAccount={onChangeAccountDebit}
            type={[Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT]}
            isSubmit={isSubmit}
            account={accountDebit}
            hiddenLimit={true}
          />
          <FormTermDeposit
            accountDebit={accountDebit}
            termInfo={termInfo}
            onSubmit={onSubmit}
            onCancel={onCancel}
            requestCreate={requestCreate}
          />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default TermDepositOpen;
